var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_vm._t("header"),_c('div',{staticClass:"shadow p-2 m-auto bg-white rounded d-flex justify-content-between flex-column"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }